import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../../../../components/shared/custom-components/Loader';
import SourceAudit from '../../../../../../../../../components/source-management/reconciliation/SourceAudit';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/reconciliation',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: SourceAudit,
  beforeLoad: () => ({ sourceType: 'exchange' }),
  staticData: {
    isClientRoute: true,
  },
});
